import styled from "styled-components";
import { Button } from "../../../Components/ContinueButton/ContinueButton.styled";

export const SaveDataButton = styled(Button)`
  background: #d4d8f9;
  border: 1px solid #d4d8f9;

  &:hover {
    background: #d4d8f9;
    border: 1px solid #d4d8f9;
  }
`;
